var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileModifiedIcon = function SvgFileModifiedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      fill: "none"
    },
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m9.75 12.5-2 2.5 2 2.5m7.5-5 2 2.5-2 2.5m-2.5-7-3 9",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.75,
    d: "M9.504 2A.5.5 0 0 0 9 2.5zm0 0h7.617c.402 0 .734 0 1.005.022.281.023.54.072.782.196.376.192.682.498.874.874.124.243.173.501.196.782.022.27.022.603.022 1.005V11.5a.5.5 0 0 1-.146.354.5.5 0 0 1-.708 0A.5.5 0 0 1 19 11.5V4.9c0-.428 0-.72-.019-.944-.018-.22-.05-.332-.09-.41a1 1 0 0 0-.437-.437c-.078-.04-.19-.072-.41-.09A13 13 0 0 0 17.1 3H10v2.12c0 .403 0 .735-.022 1.006-.023.28-.072.54-.196.782a2 2 0 0 1-.874.874c-.243.124-.501.173-.782.196C7.856 8 7.523 8 7.121 8H5v11.1c0 .428 0 .72.019.945.018.219.05.33.09.409a1 1 0 0 0 .437.437c.078.04.19.072.41.09.225.019.516.019.944.019h5.6a.5.5 0 0 1 0 1H6.88c-.403 0-.735 0-1.006-.022-.28-.023-.54-.072-.782-.196a2 2 0 0 1-.874-.874c-.124-.243-.173-.501-.196-.782C4 19.856 4 19.523 4 19.12V7.504z"
  })));
};
export default SvgFileModifiedIcon;